export default "__VITE_ASSET__553cc5ae__"